import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-[#1B7FC2] hover:underline mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>

        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-gray-500 mb-8">Last updated: January 2026</p>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing or using InsiderPass, you agree to be bound by these Terms of Service.
              If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Description of Service</h2>
            <p className="text-gray-700 leading-relaxed">
              InsiderPass is a customer loyalty platform that allows you to earn points and redeem
              rewards at participating retail businesses. Points are earned through purchases and
              other qualifying activities.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Account Registration</h2>
            <p className="text-gray-700 leading-relaxed">
              To use InsiderPass, you must:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>Provide accurate and complete registration information</li>
              <li>Verify your phone number via SMS</li>
              <li>Be at least 13 years of age</li>
              <li>Maintain the security of your account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Points and Rewards</h2>
            <p className="text-gray-700 leading-relaxed">
              Points are earned based on purchases at participating businesses. Point values,
              earning rates, and available rewards are determined by each participating business
              and may change at any time. Points have no cash value and cannot be transferred
              or sold. Unredeemed points may expire according to program rules.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. SMS Communications</h2>
            <p className="text-gray-700 leading-relaxed">
              By opting in to SMS communications, you agree to receive text messages related to
              your account, including verification codes, points updates, and rewards notifications.
              Message frequency varies. Message and data rates may apply. You may opt out at any
              time by replying STOP to any message.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Prohibited Conduct</h2>
            <p className="text-gray-700 leading-relaxed">
              You agree not to:
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>Create multiple accounts or use false information</li>
              <li>Attempt to earn points through fraudulent means</li>
              <li>Abuse, harass, or harm other users or staff</li>
              <li>Attempt to hack, disrupt, or exploit our systems</li>
              <li>Resell or transfer points or rewards</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Termination</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to suspend or terminate your account at any time for violation
              of these terms or for any other reason. Upon termination, any unredeemed points may
              be forfeited.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Disclaimer of Warranties</h2>
            <p className="text-gray-700 leading-relaxed">
              InsiderPass is provided "as is" without warranties of any kind, either express or
              implied. We do not guarantee that the service will be uninterrupted or error-free.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              To the maximum extent permitted by law, InsiderPass shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages arising from
              your use of the service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              We may modify these Terms at any time. Continued use of InsiderPass after changes
              constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">11. Contact</h2>
            <p className="text-gray-700 leading-relaxed">
              For questions about these Terms, contact us at:{' '}
              <a href="mailto:support@insiderpass.io" className="text-[#1B7FC2] hover:underline">
                support@insiderpass.io
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">12. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms shall be governed by the laws of the State of Georgia, without regard
              to its conflict of law provisions.
            </p>
          </section>
        </div>

        <p className="text-center text-gray-500 text-sm mt-8">
          © 2026 InsiderPass LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
}
